// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleDek_root__1_tnX","feature":"ArticleDek_feature__3r2zh"};